/** Textes « utilisateurs » — le français fait foi. */
export const utilisateurs = {
  familles: {
    voir: 'Consultation', creer: 'Saisie', modifier: 'Modification',
    gerer: 'Administration', cloturer: 'Clôture', accorder: 'Dérogation',
    traiter: 'Arbitrage', annuler: 'Annulation', resilier: 'Résiliation', supprimer: 'Suppression',
  } as Record<string, string>,
  /** Le nom de chaque droit. La clé est ce que le serveur vérifie. */
  capacites: {
  'voir.planning': 'Voir le planning',
  'voir.flotte': 'Voir les voitures',
  'voir.clients': 'Voir les clients',
  'voir.reservations': 'Voir les locations',
  'voir.contrats': 'Voir les contrats',
  'voir.caisse': 'Voir la caisse',
  'voir.analytique': 'Voir les chiffres et la trésorerie',
  'voir.journal': "Voir le journal d'activité",
  'creer.reservation': 'Créer une location',
  'creer.contrat': 'Établir un contrat',
  'creer.etatDesLieux': 'Faire un état des lieux',
  'creer.mouvementCaisse': 'Encaisser et dépenser',
  'creer.client': 'Créer une fiche client',
  'creer.vehicule': 'Ajouter une voiture',
  'creer.kilometrage': 'Relever les compteurs',
  'creer.entretien': 'Enregistrer un entretien, une assurance',
  'restituer.caution': 'Rendre une caution au client',
  'modifier.reservation': 'Modifier une location',
  'modifier.client': 'Modifier une fiche client',
  'modifier.vehicule': 'Modifier une voiture',
  'modifier.etatDesLieux': 'Modifier un état des lieux après enregistrement',
  'modifier.finance': 'Modifier une donnée financière',
  'gerer.taux': 'Fixer le taux du jour des devises',
  'gerer.supplements': 'Fixer le prix des suppléments',
  'voir.notes': 'Lire les notes du responsable',
  'gerer.notes': 'Écrire dans les notes du responsable',
  'gerer.utilisateurs': 'Gérer les comptes et les droits',
  'gerer.parametres': "Modifier les paramètres de l'agence",
  'cloturer.caisse': 'Clôturer la caisse',
  'accorder.derogation': "Accorder une dérogation à l'article 01",
  'traiter.correction': 'Arbitrer une demande de correction',
  'annuler.reservation': 'Annuler une location',
  'resilier.contrat': 'Résilier un contrat',
  supprimer: 'Supprimer',
} as Record<string, string>,
  droitChange: (c: string, accorde: boolean, nom: string) => `Droit « ${c} » ${accorde ? 'accorde a' : 'retiré a'} ${nom}.`,
  erreur: 'Erreur',
  titre: 'Utilisateurs et droits',
  comptes: (n: number) => `${n} compte(s)`,
  ajouter: 'Ajouter un utilisateur',
  col: { nom: 'Nom', email: 'E-mail', role: 'Rôle', dernierAcces: 'Dernier accès', etat: 'État' },
  vous: ' (vous)',
  jamais: 'jamais',
  actif: 'Actif',
  desactive: 'Désactivé',
  droits: 'Droits',
  matrice: 'Matrice des droits par rôle',
  capacite: 'Capacité',
  note: "« Modifier une donnée financière » n'est coché que pour le gérant · finances, et « modifier après enregistrement » n'est coché pour aucun agent : c'est l'irréversibilité de la saisie, votre mécanisme de contrôle principal.",
  droitsDe: (n: string) => `Droits de ${n}`,
  aideCoche: 'Coche = droit accorde. Un droit qui differe de son role est conserve comme exception sur la fiche.',
  exception: 'exception',
  fermer: 'Fermer',
  nouvel: 'Nouvel utilisateur',
  nom: 'Nom',
  email: 'E-mail',
  telephone: 'Téléphone',
  role: 'Rôle',
  motDePasse: 'Mot de passe',
  motDePasseAide: '6 caractères minimum.',
  annuler: 'Annuler',
  creer: 'Créer',
};
